<script setup>
import { ref, defineProps, defineEmits, onMounted } from "vue";
import { findAllJawTooths, resetJawTooths, attachJawToothEvents } from "../../scripts/jaw.js";

defineProps({
  modelValue: {
    type: Number,
    default: 0,
  }
});
const emit = defineEmits(['update:modelValue', 'hoverTooth']);

const tooths = ref([]);
const selectedTooth = ref({
  number: null,
  item: null,
});

function reset() {
  resetJawTooths(tooths.value);
  selected(null, null);
}

function hover(item) {
  emit('hoverTooth', item.number);
}

function select(item) {
  if (item.number === selectedTooth.value.number) {
    return;
  }

  if (null !== selectedTooth.value.item) {
    selectedTooth.value.item.classList.remove('selected');
  }

  selected(item.number, item.item);
}

function selected(number, item) {
  selectedTooth.value.number = number;
  selectedTooth.value.item = item;

  if (null !== item) {
    item.classList.add('selected');
  }

  emit('update:modelValue', selectedTooth.value.number);
}

onMounted(() => {
  tooths.value = findAllJawTooths();
  reset();
  attachJawToothEvents(tooths.value, {
    hover: hover,
    click: select,
  });
});
</script>

<template>
  <svg
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="289.61084"
    height="370.54398"
  >
    <defs>
      <marker
        refX="0"
        refY="0"
        orient="auto"
        overflow="visible"
      >
        <circle
          r="0.8"
          cy="0"
          cx="3"
        />
        <circle
          r="0.8"
          cy="0"
          cx="6.5"
        />
        <circle
          r="0.8"
          cy="0"
          cx="10"
        />
      </marker>
      <marker
        orient="auto"
        refY="0"
        refX="0"
        overflow="visible"
      >
        <path
          d="m5.77 0-8.65 5 0-10 8.65 5z"
          transform="scale(-0.2,-0.2)"
          style="
            fill-rule: evenodd;
            marker-start: none;
            stroke-width: 1pt;
            stroke: #000;
          "
        />
      </marker>
      <marker
        orient="auto"
        refY="0"
        refX="0"
        overflow="visible"
      >
        <path
          d="M0 0 5-5-12.5 0 5 5 0 0z"
          transform="matrix(0.2,0,0,0.2,1.2,0)"
          style="
            fill-rule: evenodd;
            marker-start: none;
            stroke-width: 1pt;
            stroke: #000;
          "
        />
      </marker>
      <marker
        orient="auto"
        refY="0"
        refX="0"
        overflow="visible"
      >
        <path
          d="M0 0 5-5-12.5 0 5 5 0 0z"
          transform="matrix(0.8,0,0,0.8,10,0)"
          style="
            fill-rule: evenodd;
            marker-start: none;
            stroke-width: 1pt;
            stroke: #000;
          "
        />
      </marker>
    </defs>
    <path
      class="tooth linecap-round child-tooth-51 child-tooth-51-parent"
      d="m 124.82021,113.33987 c 0.0372,0.31136 2.03838,3.51786 2.54294,4.9663 0.6822,1.56367 1.76853,2.97726 4.66113,3.72006 2.36193,-0.26358 4.75744,-0.31994 6.74559,-2.88856 l 4.88802,-6.73611 0.89133,-2.14285 c 0.64364,-1.54722 -0.75021,-2.96997 -2.05513,-3.57982 l -3.5383,-0.85742 c -2.0666,-0.1203 -3.43827,-0.67078 -7.47617,0.42903 l -3.78887,0.7507 c -1.37832,0.55227 -3.21888,0.3361 -3.25466,3.12031 0.0725,1.06423 -0.38632,2.04669 0.38412,3.21836 z"
    />
    <path
      class="tooth linecap-round child-tooth-52 child-tooth-52-parent"
      d="m 110.54038,116.16246 c 7.26885,-5.12134 5.77969,-3.6265 8.89074,-4.76501 1.08442,-0.41599 1.98459,-0.47815 2.44213,0.30939 l 1.68688,1.81986 c 1.14633,1.54619 1.07002,1.87443 1.21553,2.42363 0.54002,4.781 -0.0841,4.72099 -0.20441,6.75586 -0.83124,1.73196 -1.83506,3.27773 -3.53342,4.07416 -1.04808,0.79357 -2.49943,0.71568 -4.04124,0.44247 l -2.53533,-0.66262 c -0.994,0.16044 -1.85046,-0.55112 -2.72196,-1.16735 -1.83919,-1.38559 -2.3145,-3.35226 -2.94688,-5.25208 -0.1272,-1.22877 0.19854,-2.31724 0.94759,-3.27469 z"
    />
    <path
      class="tooth linecap-round child-tooth-53 child-tooth-53-parent"
      d="m 103.01062,138.38843 c -3.08304,-0.93467 -4.526843,-2.64459 -4.854532,-4.88241 -0.380883,-2.18802 0.04,-4.32209 1.493748,-6.38662 1.271494,-3.21518 2.533244,-3.03715 3.796044,-3.25309 1.12646,0.12908 2.15034,0.0704 3.14749,-0.0374 3.01396,-0.12134 4.13666,1.12068 4.86298,1.9331 2.54325,3.09457 2.26243,4.89771 2.88096,7.11205 0.31819,2.44502 0.1778,4.53569 -1.19659,5.67236 -4.18183,2.84207 -4.89268,1.4495 -6.64278,1.32478 -3.25902,-1.24726 -2.42079,-1.02305 -3.48732,-1.48294 z"
    />
    <path
      class="tooth child-tooth-54 child-tooth-54-parent"
      d="m 89.282654,139.5966 c 5.648888,-4.45518 9.813436,-1.88186 13.978216,0.69037 1.12472,1.26818 2.22491,2.53628 3.76531,3.80542 4.71702,4.11931 3.8298,6.91486 1.09811,9.27483 -1.70251,1.71634 -3.33311,3.4002 -4.19163,4.7356 -0.98399,0.92064 -1.88868,1.62688 -2.65708,1.96492 -3.636271,1.48371 -5.024579,-0.58561 -7.06579,-1.623 -7.33366,-3.51233 -9.959925,-8.40502 -8.072869,-14.62108 0.207935,-2.3965 1.448348,-3.58013 3.145733,-4.22706 z"
    />
    <path
      class="tooth linecap-round child-tooth-55 child-tooth-55-parent"
      d="m 76.99988,167.95696 c -1.149931,-1.43191 -0.999555,-3.51625 -0.223961,-5.91426 2.959466,-6.15977 8.276337,-7.48734 16.559191,-2.735 2.598099,0.95303 4.657723,2.7855 6.012653,4.61391 1.332827,1.79864 2.570317,2.66442 1.911497,5.84527 -1.521172,5.35819 -4.148659,9.56132 -11.595024,8.73357 -2.958672,-0.32704 -5.57148,0.37695 -9.313547,-2.28547 -1.448637,-2.17867 -4.239982,-2.0336 -3.350809,-8.25802 z"
    />
    <path
      class="tooth linecap-round child-tooth-61 child-tooth-61-parent"
      d="m 165.33459,113.36434 c -0.0372,0.31137 -2.03838,3.51787 -2.54292,4.96628 -0.68223,1.56368 -1.76853,2.97728 -4.66113,3.72008 -2.36193,-0.26357 -4.75744,-0.31992 -6.74561,-2.88858 l -4.88802,-6.73607 -0.89133,-2.14289 c -0.64363,-1.5472 0.75022,-2.96996 2.05514,-3.5798 l 3.53829,-0.85744 c 2.06661,-0.12041 3.43827,-0.67075 7.47624,0.42907 l 3.7888,0.75068 c 1.37834,0.55226 3.21891,0.33611 3.25466,3.12029 -0.0725,1.06424 0.38634,2.04671 -0.38412,3.21838 z"
    />
    <path
      class="tooth linecap-round child-tooth-62 child-tooth-62-parent"
      d="m 180.36094,116.24854 c -7.57478,-5.32687 -6.02296,-3.77204 -9.26492,-4.95626 -1.13012,-0.43265 -2.06815,-0.49734 -2.54498,0.32182 l -1.75787,1.8929 c -1.19456,1.60823 -1.11506,1.94965 -1.2667,2.52087 -0.56273,4.97288 0.0876,4.91047 0.21305,7.027 0.86618,1.80146 1.91227,3.40925 3.68212,4.23767 1.09218,0.82539 2.60468,0.74438 4.2114,0.46019 l 2.64199,-0.6892 c 1.03584,0.16688 1.92835,-0.57323 2.83654,-1.21421 1.91662,-1.44118 2.41191,-3.48678 3.07092,-5.46283 0.13261,-1.27807 -0.20688,-2.41023 -0.98747,-3.4061 z"
    />
    <path
      class="tooth linecap-round child-tooth-63 child-tooth-63-parent"
      d="m 190.54157,135.47822 c 3.08307,-0.93464 4.52683,-2.64457 4.85452,-4.88239 0.38088,-2.18804 -0.0399,-4.32208 -1.49376,-6.38661 -1.27151,-3.21521 -2.53322,-3.03715 -3.79603,-3.2531 -1.12648,0.12907 -2.15034,0.0704 -3.14743,-0.0373 -3.01397,-0.12136 -4.13673,1.12063 -4.86302,1.93308 -2.54327,3.09458 -2.26245,4.8977 -2.88098,7.11208 -0.31814,2.44499 -0.1778,4.53561 1.19657,5.6723 4.18185,2.8421 4.8927,1.44955 6.64278,1.32481 3.25904,-1.24723 2.42081,-1.02304 3.48735,-1.48295 z"
    />
    <path
      class="tooth child-tooth-64 child-tooth-64-parent"
      d="m 204.13326,136.7995 c -5.64889,-4.45518 -9.81343,-1.88188 -13.9782,0.69034 -1.12468,1.2682 -2.22493,2.53633 -3.76533,3.80544 -4.71703,4.11933 -3.82979,6.91485 -1.09811,9.27481 1.70252,1.71635 3.33311,3.40022 4.19165,4.73561 0.98398,0.92063 1.88868,1.6269 2.65707,1.96491 3.63626,1.48373 5.02457,-0.58557 7.06579,-1.62299 7.33365,-3.51232 9.95994,-8.405 8.07287,-14.62107 -0.20794,-2.39649 -1.44836,-3.58014 -3.14574,-4.22705 z"
    />
    <path
      class="tooth linecap-round child-tooth-65 child-tooth-65-parent"
      d="m 211.85238,167.75167 c 1.14994,-1.43192 0.99957,-3.51626 0.22396,-5.91425 -2.95947,-6.15977 -8.27628,-7.48737 -16.55919,-2.73499 -2.59808,0.953 -4.65771,2.78547 -6.01265,4.6139 -1.33281,1.79862 -2.57033,2.66438 -1.91149,5.84527 1.52117,5.35818 4.14865,9.56133 11.59503,8.73358 2.95865,-0.32704 5.57148,0.37694 9.31355,-2.28548 1.44863,-2.1787 4.23997,-2.03361 3.35079,-8.25803 z"
    />
    <path
      class="tooth child-tooth-71 child-tooth-71-parent"
      d="m 157.04765,249.61878 c 0.79665,2.13914 1.36106,4.50647 2.81447,5.99983 0.65206,0.79867 1.21341,1.82059 0.48859,6.00733 -0.7523,1.74435 -2.04036,2.76486 -4.06427,2.79132 -1.63238,-0.37512 -3.03759,-0.9098 -5.6045,-0.62822 -1.2359,-0.36501 -2.36238,0.12449 -3.86373,-2.31361 -0.4959,-1.15152 -1.26819,-1.88482 -0.0122,-5.68577 l 3.84535,-6.27963 c 1.04325,-0.94977 1.15734,-2.41218 3.58892,-2.59601 1.9014,0.0711 2.2579,1.4708 2.80736,2.70476 z"
    />
    <path
      class="tooth child-tooth-72 child-tooth-72-parent"
      d="m 163.16832,244.43026 c 1.00455,-3.42905 3.45759,-3.46833 5.12359,-1.82552 l 2.38653,3.6752 2.80868,3.28623 c 0.40837,1.53809 1.50705,1.44328 0.22638,6.97732 -0.77015,2.99339 -2.3191,4.33093 -4.21829,4.9239 -2.43561,0.85504 -4.52096,0.30545 -6.39837,-1.07789 -1.27985,-1.61164 -3.30565,-2.37216 -2.76176,-6.06459 0.54285,-1.66058 0.56865,-2.04881 1.7332,-5.23909 0.36668,-1.54502 0.73507,-2.30656 1.10004,-4.65556 z"
    />
    <path
      class="tooth child-tooth-73 child-tooth-73-parent"
      d="m 182.01732,234.09667 c -3.53712,-0.60748 -6.63299,-0.62741 -7.23613,2.67223 l -1.7834,6.46689 c -1.28208,4.92898 0.0639,3.93133 0.27605,5.49111 l 2.6512,3.80356 c 1.01314,1.25362 2.10478,2.43968 4.49845,2.50549 3.50956,-0.15865 7.06059,-0.22655 7.8096,-6.42156 l 0.30162,-7.23747 c -0.72778,-3.45824 -1.52434,-6.86737 -6.51739,-7.28025 z"
    />
    <path
      class="tooth child-tooth-74 child-tooth-74-parent"
      d="m 199.27678,222.0237 c 2.0578,3.46842 2.55167,5.9565 2.343,8.00435 -0.61556,3.56301 -0.93416,7.38683 -3.99852,8.79991 -4.8904,1.99162 -5.94305,0.33877 -7.92997,-0.42679 -2.27359,-1.35121 -4.06144,-3.04371 -5.34979,-5.08727 -0.99077,-0.83673 -0.91674,-1.67692 -0.95687,-2.51679 0.15307,-1.56023 -0.12159,-2.61348 -0.21976,-3.876 -0.14961,-2.44868 0.71515,-4.15778 1.20263,-6.14195 1.44194,-1.43504 2.49838,-3.40576 4.85551,-3.56915 l 4.06995,-0.14225 c 2.50703,-0.16061 4.21712,2.4977 5.98382,4.95594 z"
    />
    <path
      class="tooth child-tooth-75 child-tooth-75-parent"
      d="m 198.383,199.60633 c -5.18932,3.15259 -5.11371,4.8478 -5.27049,7.25337 0.39286,2.88118 0.28796,3.95303 0.2758,5.36194 -0.0701,2.96167 1.43908,3.74017 2.39004,5.29043 3.04952,3.72954 4.67406,2.52421 6.82572,3.14421 1.97858,-0.3725 3.18428,-0.74255 4.33214,-1.11233 3.22667,-0.95734 2.94466,-2.4393 4.168,-3.69621 1.5685,-2.57261 1.70637,-5.85991 0.87803,-9.62991 -0.67928,-2.24278 -2.05789,-3.92006 -3.50063,-5.54542 l -3.54634,-2.18544 c -2.72247,-1.3759 -5.84154,0.51296 -6.55227,1.11936 z"
    />
    <path
      class="tooth child-tooth-81 child-tooth-81-parent"
      d="m 134.25341,249.5834 c -0.79665,2.13912 -1.36102,4.50647 -2.81448,5.99982 -0.65207,0.79867 -1.21341,1.8206 -0.48858,6.00735 0.7523,1.74435 2.04033,2.76485 4.06425,2.79131 1.63241,-0.37512 3.03762,-0.9098 5.6045,-0.62821 1.23591,-0.36501 2.3624,0.12448 3.86374,-2.31361 0.49589,-1.15152 1.26818,-1.88482 0.0122,-5.68579 l -3.84536,-6.27961 c -1.04325,-0.94977 -1.15735,-2.41216 -3.58891,-2.59603 -1.90139,0.0711 -2.25789,1.47082 -2.80736,2.70477 z"
    />
    <path
      class="tooth child-tooth-82 child-tooth-82-parent"
      d="m 128.13274,244.39491 c -1.00456,-3.42909 -3.45758,-3.46836 -5.12358,-1.82555 l -2.38655,3.67521 -2.80866,3.28622 c -0.40838,1.5381 -1.50708,1.44328 -0.22638,6.97731 0.77014,2.99338 2.3191,4.33094 4.21828,4.92394 2.43561,0.85503 4.52094,0.30542 6.39837,-1.07794 1.27981,-1.6116 3.30567,-2.37213 2.76177,-6.06456 -0.54286,-1.66058 -0.56866,-2.04881 -1.73323,-5.23911 -0.36667,-1.545 -0.73509,-2.30654 -1.10002,-4.65552 z"
    />
    <path
      class="tooth child-tooth-83 child-tooth-83-parent"
      d="m 109.28374,234.06128 c 3.53711,-0.60746 6.63297,-0.62739 7.23611,2.67224 l 1.78342,6.46692 c 1.28209,4.92896 -0.0641,3.93131 -0.27605,5.49109 l -2.65119,3.80359 c -1.01316,1.25357 -2.10481,2.43963 -4.49847,2.50547 -3.50957,-0.15869 -7.06062,-0.22658 -7.80961,-6.42158 l -0.30161,-7.23747 c 0.72778,-3.45821 1.52436,-6.86736 6.5174,-7.28026 z"
    />
    <path
      class="tooth child-tooth-84 child-tooth-84-parent"
      d="m 92.024272,221.98833 c -2.057804,3.46842 -2.551663,5.95651 -2.342996,8.00434 0.615559,3.563 0.934165,7.38685 3.998519,8.79993 4.890397,1.99163 5.943042,0.33877 7.929975,-0.42683 2.27359,-1.35118 4.06144,-3.04368 5.34979,-5.08725 0.99076,-0.83673 0.91674,-1.67692 0.95686,-2.51681 -0.15305,-1.56021 0.12159,-2.61346 0.21976,-3.87599 0.14961,-2.44867 -0.71508,-4.15779 -1.20263,-6.14194 -1.44195,-1.43501 -2.49839,-3.40574 -4.85551,-3.56913 l -4.069961,-0.14226 c -2.507029,-0.16062 -4.217119,2.49768 -5.983807,4.95594 z"
    />
    <path
      class="tooth child-tooth-85 child-tooth-85-parent"
      d="m 92.918039,199.57096 c 5.189319,3.15261 5.113713,4.8478 5.2705,7.25336 -0.392855,2.88121 -0.28794,3.95306 -0.275792,5.36194 0.07019,2.96176 -1.439077,3.74019 -2.390045,5.29043 -3.049451,3.72956 -4.674063,2.52422 -6.825701,3.14422 -1.978616,-0.37253 -3.184305,-0.74254 -4.332149,-1.11234 -3.226667,-0.95732 -2.944671,-2.43932 -4.168028,-3.6962 -1.568502,-2.57262 -1.706341,-5.85989 -0.878005,-9.6299 0.679285,-2.24279 2.057877,-3.92008 3.500623,-5.54541 l 3.546321,-2.18545 c 2.722498,-1.37593 5.841551,0.51294 6.552276,1.11935 z"
    />
    <text
      xml:space="preserve"
      x="131.23643"
      y="100.53336"
      class="tooth-label"
    >
      <tspan
        x="131.23643"
        y="100.53336"
      >51</tspan>
    </text>
    <text
      xml:space="preserve"
      x="110.51928"
      y="110.66804"
      class="tooth-label"
    >
      <tspan
        x="106.51928"
        y="110.66804"
      >52</tspan>
    </text>
    <text
      xml:space="preserve"
      x="87.802124"
      y="124.42228"
      class="tooth-label"
    >
      <tspan
        x="87.802124"
        y="124.42228"
      >53</tspan>
    </text>
    <text
      xml:space="preserve"
      x="73.32402"
      y="141.07207"
      class="tooth-label"
    >
      <tspan
        x="73.32402"
        y="141.07207"
      >54</tspan>
    </text>
    <text
      xml:space="preserve"
      x="63.189354"
      y="163.51317"
      class="tooth-label"
    >
      <tspan
        x="63.189354"
        y="163.51317"
      >55</tspan>
    </text>
    <text
      xml:space="preserve"
      x="152.22969"
      y="100.53336"
      class="tooth-label"
    >
      <tspan
        x="152.22969"
        y="100.53336"
      >61</tspan>
    </text>
    <text
      xml:space="preserve"
      x="176.11855"
      y="110.66804"
      class="tooth-label"
    >
      <tspan
        x="176.11855"
        y="110.66804"
      >62</tspan>
    </text>
    <text
      xml:space="preserve"
      x="192.76837"
      y="120.80273"
      class="tooth-label"
    >
      <tspan
        x="192.76837"
        y="120.80273"
      >63</tspan>
    </text>
    <text
      xml:space="preserve"
      x="207.97037"
      y="139.62425"
      class="tooth-label"
    >
      <tspan
        x="207.97037"
        y="139.62425"
      >64</tspan>
    </text>
    <text
      xml:space="preserve"
      x="214.48553"
      y="164.96092"
      class="tooth-label"
    >
      <tspan
        x="214.48553"
        y="164.96092"
      >65</tspan>
    </text>
    <text
      xml:space="preserve"
      x="149.33405"
      y="276.44232"
      class="tooth-label"
    >
      <tspan
        x="149.33405"
        y="276.44232"
      >71</tspan>
    </text>
    <text
      xml:space="preserve"
      x="169.60339"
      y="271.375"
      class="tooth-label"
    >
      <tspan
        x="169.60339"
        y="271.375"
      >72</tspan>
    </text>
    <text
      xml:space="preserve"
      x="187.70103"
      y="262.68811"
      class="tooth-label"
    >
      <tspan
        x="187.70103"
        y="262.68811"
      >73</tspan>
    </text>
    <text
      xml:space="preserve"
      x="202.90305"
      y="244.5905"
      class="tooth-label"
    >
      <tspan
        x="202.90305"
        y="244.5905"
      >74</tspan>
    </text>
    <text
      xml:space="preserve"
      x="213.76163"
      y="217.08217"
      class="tooth-label"
    >
      <tspan
        x="213.76163"
        y="217.08217"
      >75</tspan>
    </text>
    <text
      xml:space="preserve"
      x="131.23643"
      y="275.71838"
      class="tooth-label"
    >
      <tspan
        x="131.23643"
        y="275.71838"
      >81</tspan>
    </text>
    <text
      xml:space="preserve"
      x="109.51928"
      y="269.92715"
      class="tooth-label"
    >
      <tspan
        x="109.51928"
        y="269.92715"
      >82</tspan>
    </text>
    <text
      xml:space="preserve"
      x="91.421661"
      y="259.79251"
      class="tooth-label"
    >
      <tspan
        x="91.421661"
        y="259.79251"
      >83</tspan>
    </text>
    <text
      xml:space="preserve"
      x="76.94355"
      y="240.97096"
      class="tooth-label"
    >
      <tspan
        x="76.94355"
        y="240.97096"
      >84</tspan>
    </text>
    <text
      xml:space="preserve"
      x="64.637154"
      y="217.08217"
      class="tooth-label"
    >
      <tspan
        x="64.637154"
        y="217.08217"
      >85</tspan>
    </text>

    <text
      xml:space="preserve"
      x="117.5"
      y="65"
      class="jaw-label"
    >
      <tspan
        x="117.5"
        y="65"
      >Верхняя</tspan>
    </text>
    <text
      xml:space="preserve"
      x="117"
      y="80"
      class="jaw-label"
    >
      <tspan
        x="117"
        y="80"
      >челюсть</tspan>
    </text>
    <text
      xml:space="preserve"
      x="117.5"
      y="300"
      class="jaw-label"
    >
      <tspan
        x="117.5"
        y="300"
      >Нижняя</tspan>
    </text>
    <text
      xml:space="preserve"
      x="117"
      y="315"
      class="jaw-label"
    >
      <tspan
        x="117"
        y="315"
      >челюсть</tspan>
    </text>

    <text
      xml:space="preserve"
      x="10"
      y="20"
      class="jaw-label"
    >
      <tspan
        x="10"
        y="20"
      >Право</tspan>
    </text>
    <text
      xml:space="preserve"
      x="250"
      y="20"
      class="jaw-label"
    >
      <tspan
        x="250"
        y="20"
      >Лево</tspan>
    </text>
    <text
      xml:space="preserve"
      x="10"
      y="360"
      class="jaw-label"
    >
      <tspan
        x="10"
        y="360"
      >Право</tspan>
    </text>
    <text
      xml:space="preserve"
      x="250"
      y="360"
      class="jaw-label"
    >
      <tspan
        x="250"
        y="360"
      >Лево</tspan>
    </text>
  </svg>
</template>

<style scoped>
svg {
  display: block;
  margin: auto;
}
.tooth {
  fill: none;
  stroke: #000000;
  stroke-width: 1;
  stroke-linecap: butt;
  stroke-linejoin: miter;
  stroke-miterlimit: 4;
  stroke-opacity: 1;
  stroke-dasharray: none;
  fill: white;
}
.tooth.linecap-round {
  stroke-linecap: round;
}
.tooth.active,
.tooth.active.selected {
  fill: #36B37E;
}
.tooth.selected {
  fill: #2B9467;
}
.tooth-label,
.jaw-label {
  font-size: 10px;
  font-style: normal;
  font-weight: normal;
  line-height: 125%;
  letter-spacing: 0px;
  word-spacing: 0px;
  fill: #000000;
  fill-opacity: 1;
  stroke: none;
  font-family: Sans;
}
.jaw-label {
  font-weight: bold;
  font-size: 16px;
}
</style>
